// El puesto y el tipo de trabajo de un contratado, en cristiano (S10: los elige el agente en su plan).
import { t } from '../../../i18n';
import { puesto } from '../compartido/puestos';

/** «Programador/a», o «Puesto por decidir» mientras Pau no aprueba su plan. */
export function tituloPuesto(clave: string | undefined): string {
  return (clave && puesto(clave)?.titulo) || t('oficinaV2.puesto.porDecidir');
}
